import { render, staticRenderFns } from "./SimilarQuestions.vue?vue&type=template&id=c9138d3a&"
import script from "./SimilarQuestions.vue?vue&type=script&lang=js&"
export * from "./SimilarQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SimilarQuestions.vue?vue&type=style&index=0&id=c9138d3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports